<div class="header">
  <div class="header-container">
    <div class="left-side">
      <img class="logo" src="../../../assets/images/intel-logo.png" alt="logo" />
    </div>
    <div class="right-side">
      <div class="pst-time">{{ currentPSTTime }}</div>
      <div class="nav-items">
        <div class="nav-tem" [class.active]="router.url === '/dashboard'" [routerLink]="['/dashboard']">Dashboard</div>
        <div
          class="nav-tem"
          [class.active]="router.url.startsWith('/expense-report')"
          [routerLink]="['/expense-report']">
          Expense Report
        </div>
        <div class="nav-tem" [class.active]="router.url.includes('/execution-logs')" [routerLink]="['/execution-logs']">
          Execution Logs
        </div>
        <div class="nav-tem" [class.active]="router.url === '/banking-info'" [routerLink]="['/banking-info']">
          View Banking Information
        </div>
        <div class="nav-tem" (click)="logout()">Logout</div>
      </div>
    </div>
  </div>
</div>
